import { render } from "./CampaignCard.vue?vue&type=template&id=6661730a&scoped=true&ts=true"
import script from "./CampaignCard.vue?vue&type=script&lang=ts"
export * from "./CampaignCard.vue?vue&type=script&lang=ts"

import "./CampaignCard.vue?vue&type=style&index=0&id=6661730a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6661730a"]])

export default __exports__